export enum PsModalMessages {
  ACTION_LABEL = 'Action',
  BUTTON_LABEL_EXPORT = 'Export list',
  BUTTON_LABEL_RESET_SEARCH = 'Reset search',
}
